import { render, staticRenderFns } from "./FollowupTypes.vue?vue&type=template&id=38559e0a&scoped=true"
import script from "./FollowupTypes.vue?vue&type=script&lang=js"
export * from "./FollowupTypes.vue?vue&type=script&lang=js"
import style0 from "./FollowupTypes.vue?vue&type=style&index=0&id=38559e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38559e0a",
  null
  
)

export default component.exports